<template lang="pug">
    .error
        .error-box
            .error-box__header
                | {{ $i18n.t('errors.archived_user') }}
            .error-box__body
                .error-box__text
                    | {{ $i18n.t('errors.page_no_accessFull') }}
        cs-button.error-box__button(
            pattern="primary-dark-outline",
            @click="exit()"
        )
            |   {{ $i18n.t('common.common_navigation_exit') }}
</template>

<script>
    export default {
        methods: {
            exit() {
                this.$store.dispatch('logOut');
                this.$router.push({
                    name: 'dashboard',
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/errors/errors.scss';
</style>
